import React, { useState, useEffect } from "react";
import "./TimerSection.css";
import { FaBus } from "react-icons/fa";
import Wingo_modal from "../../Common/Common_Component/Common_Modal/Wingo_modal/Wingo_modal";
import { useSocket } from "../../../utils/socket";
import { useDispatch, useSelector } from "react-redux";
import { GetAllHistory, GetAllPeriodHistory, GetPeriodResult } from "../../../features/games/color_prediction/Slice";
import Winner_Modal from "../../Common/Common_Component/Common_Modal/Winner_Modal/Winner_Modal";
import Looser_Modal from "../../Common/Common_Component/Common_Modal/Looser_Modal/Looser_Modal";
import { GETAuthLogin } from "../../../features/auth/Slice";
import Congratulation_Modal from "../../Common/Common_Component/Common_Modal/Congratulation_Modal/Congratulation_Modal";

function TimerSection({ activeTab, setActiveTab }) {
  const [modalShow, setModalShow] = useState(false);
  const [time, setTime] = useState(0); // 30 second timer
  const [period, setPeriod] = useState(); // 30 second timer

  const [showWinner, setShowWinner] = useState(false);
  const [showLooser, setShowLooser] = useState(false);
  const [winningBets, setWinningBets] = useState([]);
  const [lossBets, setLossBets] = useState([]);
  const [modalCongShow, setModalCongShow] = useState(false);

  const [resultData, setResultData] = useState(null);

  const minutes = String(Math.floor(time / 60)).padStart(2, "0");
  const seconds = String(time % 60).padStart(2, "0");

  const numSrc = [
    "/assets/images/bet_Select_section/coint_0.png",
    "/assets/images/bet_Select_section/coint_1.png",
    "/assets/images/bet_Select_section/coint_2.png",
    "/assets/images/bet_Select_section/coint_3.png",
  ];

  useSocket(`color_prediction_timer_${activeTab?.id}sec`, async (data) => {
    await setTime(data?.time);
    if (data?.time > 5) {
      await setPeriod(data?.period)
    } else {
      await setPeriod(data?.last_period)

    }
    if (data?.time === 0) {
      await dispatch(GetAllHistory())
      await GetResult()
    }
  });



  const dispatch = useDispatch();

  const periodHistory = useSelector((state) => state.games.color_prediction);

  useEffect(() => {
    dispatch(GetAllPeriodHistory({
      option_id: activeTab?.option_id
    }))
  }, [dispatch, activeTab]);


  const GetResult = async () => {
    const resultRes = await dispatch(GetPeriodResult({ period, play_time_id: activeTab?.option_id }));
    if (resultRes.meta?.requestStatus === "fulfilled") {
      const result = resultRes?.payload?.data?.result;
      const turnover_reward = resultRes?.payload?.data?.turnover_reward;
      const userResult = resultRes?.payload?.data?.user_result;

      setResultData(result);

      const wins = userResult.filter((bet) => bet?.result?.toLowerCase() === "win");
      const loss = userResult.filter((bet) => bet?.result?.toLowerCase() === "loss");
      if (turnover_reward) {
        setModalCongShow(true);
      }

      if (wins.length > 0) {
        setWinningBets(wins);
        setShowWinner(true);
        setLossBets([]);
      } else if (loss.length > 0) {
        setLossBets(loss);
        setWinningBets([]);
        setShowLooser(true);
      }

      await dispatch(GETAuthLogin())
      dispatch(GetAllPeriodHistory({
        option_id: activeTab?.option_id
      }))

    }

  }

  useEffect(() => {
    if (showLooser) {
      const timer = setTimeout(() => {
        setShowLooser(false)
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showLooser]);

  useEffect(() => {
    if (showWinner) {
      const timer = setTimeout(() => {
        setShowWinner(false)
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showWinner]);

  useEffect(() => {
    if (modalCongShow) {
      const timer = setTimeout(() => {
        setModalCongShow(false)
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [modalCongShow]);


  return (
    <>
      <section className="TimerSection">
        <div className="TimerSection_bg_holder">
          <div className="img_holder">
            <img
              className="bg_holder"
              src="/assets/images/bet_Select_section/timer_card/timer_card_bg.png"
              alt="bg"
            />
          </div>
        </div>

        <div className="timer_section">
          <div className="row me-0 ms-0">
            <div className="col-6">
              <div className="timer_left">
                <div className="game_info">
                  <div
                    className="icon_circle"
                    onClick={() => setModalShow(true)}
                  >
                    <FaBus className="bus_icon" />
                    How To Play
                  </div>

                  <div className="game_text">
                    <h4>Money King {activeTab?.label}</h4>
                  </div>

                  <div className="number_grid">
                    {periodHistory?.data?.slice(0, 4)?.map((src, index) => (
                      <div key={index} className="number_circle">
                        <img
                          src={`/assets/images/bet_Select_section/coint_${src?.Number_Result?.number}.png`}
                          className="num_img"
                          alt={`number-${index}`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-6">
              <div className="timer_right">
                <p className="time_label">Time Remaining</p>

                {/* {time && ( */}
                <div className="timer_box">
                  {time === null ? (
                    // ⏳ Show placeholder dashes until socket connects
                    <>
                      <span className="digit digit_1">-</span>
                      <span className="digit">-</span>
                      <span className="colon">:</span>
                      <span className="digit">-</span>
                      <span className="digit digit_2">-</span>
                    </>
                  ) : (
                    <>
                      <span className="digit digit_1">{minutes[0]}</span>
                      <span className="digit">{minutes[1]}</span>
                      <span className="colon">:</span>
                      <span className="digit">{seconds[0]}</span>
                      <span className="digit digit_2">{seconds[1]}</span>
                    </>
                  )}
                </div>
                {/* )} */}


                <p className="timer_id">{period}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Wingo_modal mainActiveTab={activeTab} show={modalShow} onHide={() => setModalShow(false)} />

      <Winner_Modal
        modalCongShow={modalCongShow}
        resultData={resultData}
        winningBets={winningBets}
        show={showWinner}
        onHide={() => { setModalCongShow(false); setShowWinner(false); }}
      />

      <Looser_Modal
        resultData={resultData}
        lossBets={lossBets}
        show={showLooser}
        onHide={() => { setShowLooser(false); }}
      />
      {/* <Congratulation_Modal
        show={modalCongShow}
        onHide={() => setModalCongShow(false)}
      /> */}
    </>
  );
}

export default TimerSection;